import React from 'react';

import DashboardSidebar from '../components/DashboardSidebar';
import NoteList from '../components/NoteList';
import PostList from '../components/PostList';

import OCRController from './OCRController';

import '../styles/dashboard.css';

export default class NewDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      books: [],
      collections: [],
      notes: [],
      posts: []
    };
  }

  componentWillMount() {
    const that = this;
    fetch('/api/posts', {
      credentials: 'same-origin',
      headers: {"Content-Type": "application/json"},
      method: 'GET'
    }).then(res => {
      res.json().then((posts) => {
        that.setState({posts});
      });
    });
    this.fetchNotes();
    this.fetchCollections();
    this.fetchBooks();
  }

  fetchCollections() {
    const that = this;
    fetch('/api/collections', {
      credentials: 'same-origin',
      headers: {"Content-Type": "application/json"},
      method: 'GET'
    }).then(res => {
      res.json().then((collections) => {
        that.setState({collections});
      });
    });
  }

  fetchNotes() {
    const that = this;
    fetch('/api/notes', {
      credentials: 'same-origin',
      headers: {"Content-Type": "application/json"},
      method: 'GET'
    }).then(res => {
      res.json().then((notes) => {
        that.setState({notes});
      });
    });
  }

  fetchBooks() {
    const that = this;
    fetch('/api/books', {
      credentials: 'same-origin',
      headers: {"Content-Type": "application/json"},
      method: 'GET'
    }).then(res => {
      res.json().then((books) => {
        that.setState({books});
      });
    });
  }

  getPostsForCollection() {
    if (this.props.match.params.collectionId) {
      if (this.state.collections && this.state.posts) {
        const collection = this.state.collections.find((c) => c.id == this.props.match.params.collectionId);
        if (collection) {
          const postIds = collection.items.map((ci) => ci.collection_item.item_id);
          return this.state.posts.filter((p) => postIds.indexOf(p.id) >= 0);
        }
      }
    }
    return [];
  }

  getInboxPosts() {
    if (this.state.posts && this.state.collections) {
      const allPostsInCollections = {};
      this.state.collections.forEach((c) => {
        c.items.forEach((i) => allPostsInCollections[i.collection_item.item_id] = true);
      });
      return this.state.posts.filter((p) => !allPostsInCollections[p.id]);
    }
  }

  getContent() {
    const posts = this.props.match.params.collectionId
      ? this.getPostsForCollection()
      : this.props.mode === 'inbox' ? this.getInboxPosts() : this.state.posts;

    switch (this.props.mode) {
      case 'notes':
        return <NoteList notes={this.state.notes.filter((n) => n.type !== 'ocr')} />;
      case 'ocr':
        return <OCRController notes={this.state.notes.filter((n) => n.type === 'ocr')} />;
      default:
        return <PostList collections={this.state.collections} posts={posts} />;
    }
  }

  render() {
    const navigationBase = this.props.match.params.collectionId
      ? `/collection/${this.props.match.params.collectionId}`
      : '';

    const content = this.getContent();

    return (<div className='container-fluid dashboard'>
      <div className='row'>
        <div className='col-md-3'>
          <DashboardSidebar
            active='posts'
            books={this.state.books}
            collections={this.state.collections}
            navigationBase={navigationBase} />
        </div>
        <div className='col-md-9'>
          <div className='content-list'>
            {content}
          </div>
        </div>
      </div>
    </div>);
  }
}



// WEBPACK FOOTER //
// ./src/controllers/DashboardController.js